<template>
	<div class="page-container">
		<div class="content" style="width: 100%; height: 100%">
			<div id="map-container">
				<div id="container" :style="{ height: mapHeight + 'px' }"></div>

				<div id="mapTools-container">
					<div id="mapTools" :style="{right: (hiddenFlag == false ? '15px' : '3%')}">
						<div class="tool-item" style="min-width: 40px; border-right: none"
							@click="collapseOperationTools()">
							<i class="layui-icon"
								:class="[showOperationTools ? 'iconfont fontSize18 icon-yuocecaidan-yincang' :'iconfont fontSize18 icon-zuocecaidan-yincang']"
								style="font-size: 18px; color: #707070"></i>
						</div>
						<template v-if="showOperationTools">
							<div class="tool-item" @click="changeSearchAddress()"
								:style="{background: (searchAddress ? '#EFEFEF' : 'transparent')}">
								<img src="@/assets/images/icon-search-gray.png" alt="" class="tool-icon-search" />
								<span>搜索</span>
							</div>
							<div class="tool-item" @click="getDistance()"
								:style="{background: (getRuleDistance ? '#EFEFEF' : 'transparent')}">
								<img src="@/assets/images/icon-ruler-gray.png" alt="" class="tool-icon" />
								<span>测距</span>
							</div>
							<div class="tool-item" @click="getSquare()"
								:style="{background: (getMeasureArea ? '#EFEFEF' : 'transparent')}">
								<img src="@/assets/images/icon-square-gray.png" alt="" class="tool-icon" />
								<span>面积</span>
							</div>
							<div class="tool-item" @click="changeSatelliteLayer()"
								:style="{background: (showSatelliteLayer ? '#EFEFEF' : 'transparent')}">
								<img src="@/assets/images/icon-satellite-gray.png" alt="" class="tool-icon" />
								<span>卫星</span>
							</div>
							<div class="tool-item" @click="changeTrafficLayer()"
								:style="{background: (showTrafficLayer ? '#EFEFEF' : 'transparent')}">
								<img src="@/assets/images/icon-traffic-light-gray.png" alt="" class="tool-icon" />
								<span>路况</span>
							</div>
							<div class="tool-item" @mouseenter="openIconList()" @mouseleave="closeIconList()">
								<img src="@/assets/images/icon-question-gray.png" alt="" class="tool-icon" />
								<span>图标</span>
							</div>
						</template>
					</div>
					<input type="text" id="autoComplete" placeholder="请输入您想要搜索的地址" v-model="address"
						v-show="showOperationTools && searchAddress"
						:style="{right: (hiddenFlag == false ? 'calc(7% + 15px)' : '10%')}" />
				</div>

				<div class="info-box">
					<div class="info-row">
						<label>设备名称：</label>
						<span id="chepai" v-text="plateNo || '-'"></span>
					</div>
					<div class="operation-row">
						<label>选择时间：</label>
						<div class="buttonGroup">
							<span class="btn" id="today" @click="today()">今天</span>
							<span class="btn" id="beforeday" @click="beforeday()">前一天</span>
							<span class="btn" id="afterday" @click="afterday()">后一天</span>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							开始时间:
						</div>
						<div class="input_box">
							<el-date-picker v-model="startDate" type="datetime" :clearable="false" placeholder="请选择开始时间"
								@change="getstartDate">
							</el-date-picker>
						</div>
					</div>
					<div class="input_cell">
						<div class="fontSize14 label col-333">
							结束时间:
						</div>
						<div class="input_box">
							<el-date-picker v-model="endDate" type="datetime" :clearable="false" placeholder="请选择结束时间"
								@change="getendDate">
							</el-date-picker>
						</div>
					</div>
					<div class="operation-row">
						<label v-text="iconType <= 3 ? '停车时长：' : '静止时长：'"></label>
						<div
							style="width: calc(100% - 85px);display: inline-flex;align-items: center;justify-content: space-between">
							<select id="stopTime" v-model="stopTime">
								<option value="3">3分钟</option>
								<option value="5">5分钟</option>
								<option value="10">10分钟</option>
							</select>

							<select id="trackType" name="trackType" v-model="trackType"
								:disabled="isWirelessDevice == true">
								<option value="2" v-text="iconType <= 3 ? '行驶轨迹' : '运动轨迹'"></option>
								<option value="3">明细轨迹</option>
							</select>
						</div>
					</div>
					<div class="operation-row search-button">
						<span class="btn bgStyle" id="queryLine" @click="queryLine()">查询</span>
					</div>

					<div class="operation-row" style="line-height: 50px;padding-top: 15px">
						<img src="@/assets/images/icon-play-before-blue.png" id="speedDown" @click="speedDown()"
							alt="" />
						<img :src="isPlaying == false ? require('@/assets/images/icon-play-button-blue.png') : require('@/assets/images/icon-stop-red-big.png') "
							id="playButton" @click="playButton($event)" alt="" />
						<img src="@/assets/images/icon-play-after-blue.png" id="speedUp" @click="speedUp()" alt="" />
						<input type="range" min="0" max="100" value="0" disabled="disabled" @input="swipeRange($event)"
							@change="finishSwipeRange($event)" style="width: 80%;" />
						<!--                    <span id="collapse" class="btn bgStyle" @click="bottomCollapse($event)">明细</span>-->
					</div>


					<div class="info-row" style="margin-top: 20px;border-top: 1px solid #e5e5e5">
						<label>设备ID：</label>
						<span id="deviceId" v-text="device || '-'"></span>
					</div>
					<div class="info-row">
						<label v-text="iconType <= 3 ? '行车时长：' : '运动时长：'"></label>
						<span id="accOnTime" v-text="accOnTime || '-'"></span>
					</div>
					<div class="info-row">
						<label v-text="iconType <= 3 ? '停车时长：' : '静止时长：'"></label>
						<span id="carStopTime" v-text="carStopTime || '-'"></span>
					</div>
					<div class="info-row">
						<label>最高时速：</label>
						<span id="maxSpeed" v-text="(maxSpeed || 0) + ' km/h'"></span>
					</div>
					<div class="info-row">
						<label>平均时速：</label>
						<span id="averageSpeed" v-text="(averageSpeed || 0) + ' km/h'"></span>
					</div>
					<div class="info-row">
						<label>总里程：</label>
						<span id="mileage" v-text="formatMileage(mileage) || 0 + 'km'"></span>
					</div>
				</div>

				<div class="detailList-row"
					:style="{bottom: (showTrackDetail == true ? 'calc(1.5% + 250px)' : '1.5%')}">
					<span class="detailList" v-cloak="" @click="bottomCollapse($event)"><img
							src="@/assets/images/icon-arrow-down-white.png" class="arrow-down"
							:style="{transform: (showTrackDetail == true ? 'rotateX(0deg)' : 'rotateX(180deg)')}">明细列表</span>
				</div>
				<div id="trackInfo" v-show="showTrackDetail === true" style="display: none">
					<div id="trackDetail" class="clusterize">
						<div class="title">
							<div class="operation-item">
								<h5>轨迹详情</h5>
							</div>
							<div class="operation-item">
								<span class="operation" id="getAddress" @click="getAddress()">
									<img src="@/assets/images/icon-location-address.png" style="width: 20px" alt="">
									<span>查询轨迹点地址</span>
								</span>
								<span class="operation" id="export" @click="exportData()">
									<img src="@/assets/images/daochu.png" style="width: 18px;" alt="" />
									<span>导出</span>
								</span>
							</div>
						</div>
						<div id="showTrackDetailTable">
							<ul id="list">
								<li>
									<span>序号</span>
									<span>服务器时间</span>
									<span>卫星时间</span>
									<span>卫星信号</span>
									<span>经度</span>
									<span>纬度</span>
									<span>速度</span>
									<span>引擎</span>
									<span>状态</span>
									<span>参考里程</span>
									<span>位置</span>
								</li>
								<div id="listBox">
									<template v-if="track.length > 0">
										<DynamicScroller id="scroller" class="scroller" :items="track"
											:min-item-size="45" key-field="gpsT">
											<template v-slot="{ item, index, active }">
												<DynamicScrollerItem :item="item" :active="active" :data-index="index">
													<li :data-index="index" @click="clickTrajectoryRow(index + 1)"
														:style="{background: (currentTrajectoryIndex === (index + 1) ? '#DDDDDD' : 'transparent')}">
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{index + 1}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{formatDatetime(item.serT)}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{formatDatetime(item.gpsT)}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{item.av == '0' ? '基站' : '卫星'}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{parseFloat(item.lng).toFixed(6)}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{parseFloat(item.lat).toFixed(6)}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{item.sp + 'km/h'}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{item.acc == "1" ? '启动' : '停止'}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{(item.alarmDetail.length > 0 ? item.alarmDetail + ',' : '') + (item.stopT != null ? (item.stopT > parseInt(stopTime) * 60 ? (iconType <= 3 ? '停车' : '静止') + timeDeltaCount(item.stopT) : '') : '')}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{formatMileage(item.sumMileage)}}</span>
														<span
															:class="item.av == '1' ? 'satellitePositioning' : 'stationPositioning'">{{item.hasOwnProperty('address') ? item.address : ""}}</span>
													</li>

												</DynamicScrollerItem>
											</template>
										</DynamicScroller>
									</template>
								</div>
							</ul>
						</div>
					</div>
				</div>
			</div>
			<text-tips ref="textTips"></text-tips>
			<div class="bgBlock" v-show="isDataLoading === true">
				<div class="load">
					<img src="@/assets/images/load.gif" alt="" />
					<el-progress :text-inside="true" :stroke-width="16" style="width: 200px; margin-top: 15px"
						:percentage="formatProgressPercentage"
						v-show="showLoadingPercentage == true && searchDayCount > 1"></el-progress>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		ref,
		nextTick,
		onMounted,
		onUnmounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import {
		parseTime,
		formatDateString,
		formatDatetime,
	} from "@/libs/tools";
	import {
		getShowIcon,
		getACCStatus,
		getCarStatus,
		formatMileage,
		getUrlParam,
		isSupportCanvas,
		timeDeltaCount,
	} from "@/libs/mapUtils";
	import AMapLoader from "@amap/amap-jsapi-loader";
	import {
		throwStatement
	} from "@babel/types";
	import {
		dataTool
	} from "echarts";
	import $ from 'jquery';

	export default defineComponent({
		components: {},
		name: "vehicleMapTrack",

		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const startDate = ref();
			const endDate = ref();

			const formatProgressPercentage = computed(() => {
				if (data.progressPercentage < 0) {
					return 0;
				} else if (data.progressPercentage >= 0 && data.progressPercentage <= 100) {
					return parseFloat((data.progressPercentage * 100) / 100);
				} else if (data.progressPercentage > 100) {
					return 100;
				}
			});

			const maxSpeed = computed(() => {
				var maxSpeed = 0,
					speedArray = data.speedArr;

				speedArray.forEach(function(item) {
					if (parseInt(item) > maxSpeed) {
						maxSpeed = parseInt(item);
					}
				})

				return maxSpeed;
			});

			const searchDayCount = computed(() => {
				var startTime = startDate.value,
					endTime = endDate.value;

				if (startTime && endTime) {
					return Math.floor(Math.floor(Math.floor(((new Date(endTime.replace(/-/g, "/"))
						.getTime() / 1000) - (new Date(startTime.replace(/-/g,
							"/"))
						.getTime() / 1000)) / 60) / 60) / 24) + 1;
				} else {
					return 0;
				}
			});

			const searchDayList = computed(() => {
				var startTime = startDate.value,
					endTime = endDate.value,
					searchDayList = [];
				var startDateTemp = startTime.split(' ')[0];

				if (searchDayCount.value > 1) {
					for (var i = 0; i < searchDayCount.value; i++) {
						var currentDate = new Date(new Date(startDateTemp).getTime() + (i * 24 *
							60 * 60 *
							1000));
						var formatCurrDate = currentDate.getFullYear() + '-' +
							((currentDate.getMonth() + 1) < 10 ? ('0' + (currentDate.getMonth() +
								1)) : (
								currentDate.getMonth() + 1)) + '-' +
							(currentDate.getDate() < 10 ? ('0' + currentDate.getDate()) :
								currentDate
								.getDate());

						if (i == 0) {
							searchDayList.push({
								startTime: startTime,
								endTime: formatCurrDate + ' 23:59:59'
							})
						} else if (i == searchDayCount.value - 1) {
							searchDayList.push({
								startTime: formatCurrDate + ' 00:00:00',
								endTime: endTime
							})
						} else {
							searchDayList.push({
								startTime: formatCurrDate + ' 00:00:00',
								endTime: formatCurrDate + ' 23:59:59'
							})
						}
					}
				} else {
					searchDayList.push({
						startTime: startTime,
						endTime: endTime
					})
				}

				return searchDayList;
			});

			const data = reactive({
				screenWidth: document.documentElement.clientWidth,
				screenHeight: document.documentElement.clientHeight,
				tableId: "roleManagementTable",
				dayType: "n",
				mapHeight: 400,
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				orgId: "",
				orgList: [],
				maplist: [],
				map: null,
				startPointMarker: null,
				endPointMarker: null,
				pathSimplifierIns: null,
				pathNavigator: null,
				circle: null,
				startTime: "",
				endTime: "",
				value1: [],
				markers: [],
				isShow: true,
				newArr: [],
				orderList: [],
				radius: null,
				odrGatherCount: "",
				mapItemList: [],
				positionData: null,
				iconType: 1,
				plateNo: getUrlParam('plateNo') || '-',
				vehicleID: getUrlParam('vehicleID') || '-',
				mileage: 0,
				stopTime: 3,
				trackType: 2, // 查询轨迹类型(0:多天行驶轨迹 1:多天明细轨迹 2:单天行驶轨迹 3:单天明细轨迹)
				range: '',
				stopList: [],
				cacheTrack: [],
				showLoadingPercentage: false,
				progressPercentage: 0,
				track: Object.freeze([]),
				lineArr: Object.freeze([]),
				newLineArr: Object.freeze([]),
				speedArr: Object.freeze([]),
				timeArr: Object.freeze([]),
				playSpeed: 1000,
				passLength: 0,
				passPercentage: 0,
				currentTrajectoryIndex: -1,

				circlesList: [], //圆形数组
				areaList: [], //区域数组
				areaOrderList: [],
				isShowArea: true,
				index: 0,
				minPoints: null,
				areaAllOrder: [],
				odrCount: 0,
				selectedRows: [], // 用于存储选中的行数据数组。
				canSendInstruction: false,
				canUpdateVehicle: false,
				tabType: 'all',
				infoWindow: null,
				infoWindow2: null,
				countdownSeconds: 60,
				countdownLimitSeconds: 60,
				hiddenFlag: true,
				showTrackDetail: false,
				isPlaying: false,
				isDataLoading: false,
				stopSumTime: 0,
				driveSumTime: 0,
				sumTime: 0,
				thermody: [],

				showOperationTools: true, // 是否展示全部地图工具
				address: '', // 地址搜索关键字

				searchAddress: false, // 是否处于搜索地址状态
				getRuleDistance: false, // 是否处于测距状态
				getMeasureArea: false, // 是否处于测量面积状态
				showSatelliteLayer: false, // 是否显示卫星地图
				showTrafficLayer: false, // 是否显示交通地图
			});


			onMounted(() => {
				nextTick(() => {
					var offsetHeight = document.querySelector("#map-container").offsetHeight;
					if (offsetHeight <= 0) {
						return false;
					}
					data.mapHeight = document.querySelector(" #map-container").offsetHeight;

					document.title = '轨迹回放_' + data.plateNo;
					data.range = $('.info-box').find('input[type=range]')

					var date = new Date();
					startDate.value = formatDatetime(date.getFullYear() + '-' + (date.getMonth() +
						1) + '-' + date.getDate() + ' ' + '00:00:00');
					endDate.value = formatDatetime(date.getFullYear() + '-' + (date.getMonth() +
							1) + '-' + date.getDate() + ' ' +
						date.getHours() + ':' + date.getMinutes() + ':00');

					initMap();


				});


				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = 200;

						// 监听浏览器大小发生改变
						data.screenWidth = document.documentElement.clientWidth;
						data.screenHeight = document.documentElement.clientHeight;
					});
				};

			});

			onUnmounted(() => {

				if (data.map !== null && data.map !== undefined) {
					data.map.destroy();
					data.map = null;
				}
			});


			//初始化地图
			const initMap = () => {
				AMapLoader.load({
						key: "e43a295f15ed06c429ff79a20f5331f0",
						version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
						plugins: [
							"AMap.Geolocation",
							"AMap.AutoComplete",
							"AMap.PlaceSearch",
							"AMap.Geocoder",
							"AMap.IndexCluster",
							"AMap.MarkerClusterer",
						], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
						AMapUI: {
							// 是否加载 AMapUI，缺省不加载
							version: "1.1", // AMapUI 版本
							plugins: ["overlay/SimpleMarker"], // 需要加载的 AMapUI ui插件
						},
						Loca: {
							// 是否加载 Loca， 缺省不加载
							version: "2.0", // Loca 版本
						},
					})
					.then((AMap) => {
						// console.log(AMap)
						data.map = new AMap.Map("container", {
							//设置地图容器id
							viewMode: "3D", //是否为3D地图模式
							zoom: 5, //初始化地图级别
							center: [113.683515, 34.752721], //初始化地图中心点位置
							animateEnable: false,
						});

						data.infoWindow = new AMap.InfoWindow({
							offset: new AMap.Pixel(5, -30),
							zIndex: 6,
						});
					})

			};

			const bottomCollapse = (event) => {

				data.showTrackDetail = !data.showTrackDetail;
			};

			const getstartDate = (ev) => {
				startDate.value = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(startDate.value);
			};

			const getendDate = (ev) => {
				endDate.value = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(endDate.value);
			};

			const GetDateStr = (AddDayCount) => {
				var dd = new Date();
				dd.setDate(dd.getDate() + AddDayCount);
				return dd.getFullYear() + "-" + (dd.getMonth() + 1) + "-" + dd.getDate();
			};

			const today = () => {
				if (data.isPlaying === false) {
					startDate.value = formatDatetime(GetDateStr(0) + ' ' + '00:00:00');
					endDate.value = formatDatetime(GetDateStr(0) + ' ' + '23:59:59');
					// that.searchLine(that.startDate, that.endDate);
					// that.range.removeAttr("disabled");
				}
			};

			const beforeday = () => {
				var beforeDate = new Date(new Date(startDate.value) - (24 * 60 * 60 * 1000));
				var beforeTime = new Date(new Date(endDate.value) - (24 * 60 * 60 * 1000));

				if (data.isPlaying === false) {
					startDate.value = formatDatetime(beforeDate.getFullYear() + '-' + (beforeDate.getMonth() +
							1) + '-' + beforeDate.getDate() + ' ' + beforeDate.getHours() + ':' +
						beforeDate.getMinutes() + ':' + beforeDate.getSeconds());
					endDate.value = formatDatetime(beforeTime.getFullYear() + '-' + (beforeTime.getMonth() +
						1) + '-' + beforeTime.getDate() + ' 23:59:59')
					// that.searchLine(that.startDate, that.endDate);
					// that.range.removeAttr("disabled");
				}
			};

			const afterday = () => {
				var afterDate = new Date(new Date(startDate.value).getTime() + (24 * 60 * 60 * 1000));
				var afterTime = new Date(new Date(endDate.value).getTime() + (24 * 60 * 60 * 1000));

				if (data.isPlaying === false) {
					startDate.value = formatDatetime(afterDate.getFullYear() + '-' + (afterDate.getMonth() +
							1) + '-' + afterDate.getDate() + ' ' + afterDate.getHours() + ':' +
						afterDate.getMinutes() + ':' + afterDate.getSeconds())
					endDate.value = formatDatetime(afterTime.getFullYear() + '-' + (afterTime.getMonth() + 1) +
						'-' + afterTime.getDate() + ' ' + afterTime.getHours() + ':' +
						afterTime.getMinutes() + ':' + afterTime.getSeconds());
					// that.searchLine(that.startDate, that.endDate);
					// that.range.removeAttr("disabled");
				}
			};

			const playButton = (event) => {

				if (data.lineArr.length > 1) {
					if (data.isPlaying === false) {
						if (data.passPercentage > 0 && data.passPercentage < 100) {
							if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
								.pathNavigator !== '') {
								if (!data.pathNavigator.isCursorAtPathEnd()) {
									data.pathNavigator.resume();
								} else {
									data.pathNavigator.start();
								}
							}
						} else {
							if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
								.pathNavigator !== '') {
								data.pathNavigator.start();
							}
						}
						data.isPlaying = true;
					} else {
						if (data.passPercentage > 0 && data.passPercentage < 100) {
							if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
								.pathNavigator !== '') {
								data.pathNavigator.pause();
							}
						} else {
							if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
								.pathNavigator !== '') {
								data.pathNavigator.stop();
							}
						}
						data.isPlaying = false;
					}
				} else {
					alert('当前暂无轨迹信息！');
				}
			};

			const speedDown = () => {
				if (data.playSpeed - 100 >= 0) {
					data.playSpeed = data.playSpeed - 100;

					if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
						.pathNavigator !== '') {
						data.pathNavigator.setSpeed(data.playSpeed);
					}
				}
			};

			const speedUp = () => {
				if (data.playSpeed + 100 <= 2000) {
					data.playSpeed = data.playSpeed + 100;

					if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
						.pathNavigator !== '') {
						data.pathNavigator.setSpeed(data.playSpeed)
					}
				}
			};

			const swipeRange = (event) => {
				var nowPassedPercentage = Math.round(data.track.length * (parseFloat($(event.target).val() /
					100).toFixed(2)));

				if (data.lineArr.length > 0) {
					$(event.target).css('background-size', $(event.target).val() + '% 100%');

					if (nowPassedPercentage === 0) {
						data.currentTrajectoryIndex = 1;
					} else if (nowPassedPercentage > 0 && nowPassedPercentage < data.track.length - 1) {
						data.currentTrajectoryIndex = nowPassedPercentage + 1;
					} else {
						data.currentTrajectoryIndex = nowPassedPercentage;
					}

					// if (nowPassedPercentage * 45 < that.track.length * 45) {
					//     document.getElementById('scroller').scrollTop = (nowPassedPercentage - 1) * 45;
					// } else {
					document.getElementById('scroller').scrollTop = nowPassedPercentage * 45;
					// }


					data.passLength = nowPassedPercentage;
					data.passPercentage = parseFloat((data.passLength / data.track.length)).toFixed(2);

					if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
						.pathNavigator !== '') {
						data.pathNavigator.moveToPoint(nowPassedPercentage, 0);
					}
					if (data.pathSimplifierIns !== null && data.pathSimplifierIns !== undefined && data
						.pathSimplifierIns !== '') {
						data.pathSimplifierIns.renderLater();
					}


					data.infoWindow2.setContent("<div  style='padding: 10px 10px;'>" +
						"<div class='right' style='width:100%;float:right;margin: 0 6%;font-size:12px'>" +
						"<p style='line-height:20px'>名称：" + data.plateNo + "</p>" +
						"<p style='line-height:20px'>速度：" + data.speedArr[data.passLength] + "km/h</p>" +
						"<p style='line-height:20px'>时间：" + formatDate(data.timeArr[data.passLength]) +
						"</p>" +
						"</div>" +
						"</div>");
					data.infoWindow2.open(data.map, data.pathNavigator.getPosition());
				} else {
					$(event.target).attr('disabled', 'disabled');
					if (data.lineArr.length === 0) {
						alert("暂无轨迹信息！")
					}
				}
			};

			const finishSwipeRange = () => {
				data.map.setCenter(data.pathNavigator.getPosition())

				// if (that.passLength * 45 < that.track.length * 45) {
				//     document.getElementById('scroller').scrollTop = (that.passLength - 1) * 45;
				// } else {
				document.getElementById('scroller').scrollTop = data.passLength * 45;
				// }

				setTimeout(function() {
					if (data.passLength === 0) {
						data.currentTrajectoryIndex = 0;
					} else if (data.passLength > 0 && data.passLength < data.track.length - 1) {
						data.currentTrajectoryIndex = data.passLength + 1;
					} else {
						data.currentTrajectoryIndex = data.passLength;
					}
				}, 0.05 * 1000)
			};

			const clickTrajectoryRow = (index) => {

				if (index != null && index !== undefined && index !== '') {
					if (data.lineArr.length > 0 && !data.isPlaying) {
						data.currentTrajectoryIndex = parseInt(index);
						$('.bottom').find('input[type=range]').val((parseInt(index) / data.lineArr.length) *
							100);
						$('.bottom').find('input[type=range]').css('background-size', (parseInt(index) / data
							.lineArr.length) * 100 + '% 100%');

						data.passLength = parseInt(index) - 1;
						data.passPercentage = parseFloat((data.passLength / data.track.length)).toFixed(2);


						// pathNavigator移动到指定位置
						if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
							.pathNavigator !== '') {
							data.pathNavigator.moveToPoint(data.passLength, 0);
						}
						if (data.pathSimplifierIns !== null && data.pathSimplifierIns !== undefined && data
							.pathSimplifierIns !== '') {
							data.pathSimplifierIns.renderLater();
						}


						// 轨迹点是基站定位的,显示粗略定位范围
						if (data.track[data.passLength].av == '0') {
							var lbsData = data.track[data.passLength].lbsdata.split('|');

							if (lbsData[0] !== null && lbsData[1] !== null && lbsData[2] !== null && lbsData[
									3] !== null) {
								$.ajax({
									url: commonUrl + "/vehicleTerminal/getLBSP",
									async: true,
									data: {
										MCC: lbsData[0],
										MNC: lbsData[1],
										LAC: lbsData[2],
										CELL: lbsData[3]
									},
									xhrFields: {
										withCredentials: true // 这里设置了withCredentials
									},
									success: function(res) {
										if (res.code === 0) {
											circle = new AMap.Circle({
												center: new AMap.LngLat(res.O_LNG || res
													.lng, res.O_LAT || res.lat),
												radius: 200,
												map: map,
												fillColor: '#f3f2a2',
												strokeColor: '#243290',
												strokeWeight: 1,
												zIndex: 1,
											});
										} else {
											circle = null;
										}
									}
								});
							} else {
								if (circle != null && circle != undefined && circle != '') {
									circle.setMap(null);
									circle = null;
								}
							}
						} else {
							if (circle != null && circle != undefined && circle != '') {
								circle.setMap(null);
								circle = null;
							}
						}


						// 获取对应记录地址
						AMap.plugin('AMap.Geocoder', function() {
							var geocoder = new AMap.Geocoder();
							geocoder.getAddress([data.track[parseInt(index) - 1].lng, data.track[
								parseInt(index) - 1].lat], function(status, result) {
								if (status === 'complete' && result.info === 'OK') {
									data.$set(data.track[parseInt(index) - 1], 'address',
										result.regeocode.formattedAddress);
								}
							});
						});


						data.infoWindow2.setContent("<div  style='padding: 10px 10px;'>" +
							"<div class='right' style='width:100%;float:right;margin: 0 6%;font-size:12px'>" +
							"<p style='line-height:20px'>名称：" + data.plateNo + "</p>" +
							"<p style='line-height:20px'>速度：" + data.speedArr[data.passLength] +
							"km/h</p>" +
							"<p style='line-height:20px'>时间：" + formatDate(data.timeArr[data.passLength]) +
							"</p>" +
							"</div>" +
							"</div>");
						data.infoWindow2.open(data.map, data.pathNavigator.getPosition());
					} else {
						if (data.lineArr.length === 0) {
							alert("暂无轨迹信息！")
						} else if (data.isPlaying) {
							alert("当前处于播放轨迹状态，暂时无法进行其他操作！")
						}
					}
				}
			};

			const queryLine = () => {

				if (data.isPlaying === false) {
					searchLine(startDate.value, endDate.value);
					data.range.removeAttr("disabled");
				}
			};

			const searchLine = (beginDate, endDate) => {

				if (data.plateNo !== undefined && data.plateNo !== null && data.plateNo !== '') {
					if (beginDate > endDate) {
						alert('开始时间不能大于结束时间！');
					} else if (data.trackType == 2 && Math.floor((new Date(endDate.replace(/-/g, "/")) -
							new Date(beginDate.replace(/-/g, "/"))) / 1000 / 60 / 60 / 24) > 30) {
						alert('只能查询开始时间和结束时间相隔三十天内的行驶轨迹数据！')
					} else if (data.trackType == 3 &&
						Math.floor((new Date(endDate.replace(/-/g, "/")) - new Date(beginDate.replace(/-/g,
							"/"))) / 1000 / 60 / 60 / 24) > 2) {
						alert('只能查询开始时间和结束时间相隔两天内的明细轨迹数据！')
						// } else if (data.trackType == 3 && that.isWirelessDevice == true &&
						//     Math.floor((new Date(endDate.replace(/-/g, "/")) - new Date(beginDate.replace(/-/g, "/"))) / 1000 / 60 / 60 / 24) > 30) {
						//     alert('只能查询开始时间和结束时间相隔三十天内的明细轨迹数据！')
					} else {
						/* ----------------------------------- 重置数据 ----------------------------------- */
						data.cacheTrack = [];
						data.progressPercentage = 0;

						// if (document.getElementById('scroller')) {
						//     document.getElementById('scroller').scrollTop = 0;
						// }
						// that.currentTrajectoryIndex = -1;
						data.range.val(0);
						data.range.css('background-size', '0% 100%');


						data.map.clearMap();
						data.track = [];
						data.newLineArr = [];
						data.lineArr = [];
						data.speedArr = [];
						data.timeArr = [];
						data.stopSumTime = 0;
						data.driveSumTime = 0;
						data.sumTime = 0;
						data.mileage = 0;

						if (data.startPointMarker !== null && data.startPointMarker !== undefined && data
							.startPointMarker !== '') {
							data.startPointMarker.setMap(null);
							data.startPointMarker = null;
						}

						if (data.endPointMarker !== null && data.endPointMarker !== undefined && data
							.endPointMarker !== '') {
							data.endPointMarker.setMap(null);
							data.endPointMarker = null;
						}

						if (data.stopList.length > 0) {
							data.stopList.forEach(function(item, index) {
								if (item != null && item != undefined && item != '') {
									item.setMap(null);
									item = null;
								}
							})
							data.stopList = [];
						}

						if (data.pathSimplifierIns !== null && data.pathSimplifierIns !== undefined && data
							.pathSimplifierIns !== '') {
							data.pathSimplifierIns.setData([]);
							data.pathSimplifierIns = null;
						}

						if (data.pathNavigator !== null && data.pathNavigator !== undefined && data
							.pathNavigator !== '') {
							data.pathNavigator.destroy();
							data.pathNavigator = null;
						}

						if (data.circle !== null && data.circle !== undefined && data.circle !== '') {
							data.circle.setMap(null);
							data.circle = null;
						}
						/* ------------------------------------------------------------------------------- */

						data.isDataLoading = true;
						data.showLoadingPercentage = true;
						getTrackData(0);
					}
				} else {
					alert('请先选择设备然后再查询轨迹！');
				}
			};

			const getTrackData = async (index) => {

				let params = {
					vehId: data.vehicleID,
					startTime: searchDayList.value[index].startTime,
					endTime: searchDayList.value[index].endTime,
					type: parseInt(data.trackType),
				};
				const r = await proxy.$http.postFormData(apiObj.getVehTraffic, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.tableData = r.list;

					r.list.forEach(function(item) {
						data.cacheTrack.push(item)
					})

					data.stopSumTime += r.stopSumTime;
					data.driveSumTime += r.driveSumTime;
					//data.sumTime += r.sumTime;


					// if (r.hasOwnProperty('object')) {
					// 	if (r.object !== null) {
					// 		data.stopSumTime += r.object.stopSumTime;
					// 		data.driveSumTime += r.object.driveSumTime;
					// 		data.sumTime += r.object.sumTime;


					// 		if (r.object.hasOwnProperty('data')) {
					// 			r.object.data.forEach(function(item) {
					// 				data.cacheTrack.push(item)
					// 			})
					// 		}

					// 		if (r.object.hasOwnProperty('thermody')) {
					// 			r.object.thermody.forEach(function(item) {
					// 				data.thermody.push(item)
					// 			})
					// 		}
					// 	}
					// } else {
					// 	alert("暂无轨迹信息！");
					// }

					data.progressPercentage = parseFloat(((index + 1) / searchDayCount.value) * 100)
						.toFixed(2);
					nextTick(() => {
						calculateLoadingStatus();
					});

				} else {
					data.isDataLoading = false;
					alert('查询轨迹信息失败！');
				}


				function calculateLoadingStatus() {
					if (index + 1 !== searchDayCount.value) {
						getTrackData(index + 1)
					} else {
						//that.previousDevice = that.device;
						//that.initHeatMap(that.thermody);//热力图

						if (data.cacheTrack !== null && data.cacheTrack !== undefined) {
							var minStopTime = parseInt(data.stopTime) * 60;
							var sumMileage = 0,
								alarmDetail = '';

							if (data.cacheTrack.length > 0) {
								data.cacheTrack.forEach(function(v1, i1) {
									sumMileage += parseInt(v1.dis);
									alarmDetail = '';

									if (v1.wname !== '[]' && v1.sname !== '[]') {
										alarmDetail = v1.wname.substr(1, v1.wname.length - 1) +
											',' +
											v1.sname.substr(1, v1.sname.length - 1);
									} else if (v1.wname === '[]' && v1.sname !== '[]') {
										alarmDetail = v1.sname.substr(1, v1.sname.length - 1);
									} else if (v1.wname !== '[]' && v1.sname === '[]') {
										alarmDetail = v1.wname.substr(1, v1.wname.length - 1);
									}

									v1.id = i1;
									v1.alarmDetail = alarmDetail;
									v1.sumMileage = sumMileage;
									data.newLineArr[i1] = [v1.lng, v1.lat];
									data.lineArr[i1] = [v1.lng, v1.lat];
									data.speedArr[i1] = v1.sp;
									data.timeArr[i1] = v1.serT;


									// that.$set(v1, 'id', i1);
									// that.$set(v1, 'alarmDetail', alarmDetail);
									// that.$set(v1, 'sumMileage', sumMileage);


									// that.$set(that.newLineArr, i1, [v1.lng, v1.lat]);
									// that.$set(that.lineArr, i1, [v1.lng, v1.lat]);
									// that.$set(that.speedArr, i1, v1.sp);
									// that.$set(that.timeArr, i1, v1.serT);

									data.lineArr.push([v1.lng, v1.lat]);

									if (parseInt(i1) == 0) {
										data.startPointMarker = new AMap.Marker({
											position: [v1.lng, v1.lat],
											map: data.map,
											icon: new AMap.Icon({
												size: new AMap.Size(30, 30), //图标大小
												image: require(
													'@/assets/images/hstart.png'
												),
												imageOffset: new AMap.Pixel(0, 0)
											})
										})

										data.startPointMarker.on('click', function(e) {
											var i = "";
											AMap.plugin('AMap.Geocoder', function() {
												var geocoder = new AMap.Geocoder({
													batch: true
												});
												geocoder.getAddress(e.target
													.getPosition(),
													function(status, result) {
														i = result.regeocode
															.formattedAddress;
														data.infoWindow
															.setContent(
																"<div class='markerContent' style='width: 200px;border-radius: 10px;padding:10px 0;background: #ffffff'>" +
																"   <p style='font-size: 13px'>开始点</p>" +
																"   <p style='font-size: 13px'>时间：" +
																formatDatetime(
																	v1
																	.serT) +
																"</p>" +
																"   <p style='font-size: 13px'>地址：" +
																i + "</p>" +
																"</div>");
														data.infoWindow.open(
															data.map, e
															.target
															.getPosition());
													});
											});
										});

									} else if (parseInt(i1) == data.cacheTrack.length - 1) {
										data.endPointMarker = new AMap.Marker({
											position: [v1.lng, v1.lat],
											map: data.map,
											icon: new AMap.Icon({
												size: new AMap.Size(30, 30), //图标大小
												image: require(
													'@/assets/images/hend.png'
												),
												imageOffset: new AMap.Pixel(0, 0)
											})
										});

										data.endPointMarker.on('click', function(e) {
											var i = "";
											AMap.plugin('AMap.Geocoder', function() {
												var geocoder = new AMap.Geocoder({
													batch: true
												});
												geocoder.getAddress(e.target
													.getPosition(),
													function(status, result) {
														i = result.regeocode
															.formattedAddress;
														data.infoWindow
															.setContent(
																"<div class='markerContent' style='width: 200px;border-radius: 10px;padding:10px 0;background: #ffffff'>" +
																"   <p style='font-size: 13px'>结束点</p>" +
																"   <p style='font-size: 13px'>时间：" +
																formatDatetime(
																	v1
																	.serT) +
																"</p>" +
																"   <p style='font-size: 13px'>地址：" +
																i + "</p>" +
																"</div>");
														data.infoWindow.open(
															data.map, e
															.target
															.getPosition());
													});
											});
										});
									}


									if (v1.stopT != null) {
										if (Math.abs(v1.stopT) > (parseInt(data.stopTime) * 60)) {
											var marker = new AMap.Marker({
												position: [v1.lng, v1.lat],
												map: data.map,
												icon: new AMap.Icon({
													size: new AMap.Size(30,
														30), //图标大小
													image: require(
														'@/assets/images/hp.png'
													),
													imageOffset: new AMap.Pixel(0,
														0)
												}),
											})


											/*marker.content = "<div class='markerContent' style='width: 200px;border-radius: 10px;padding:10px 0;background: #ffffff'>" +
			                                    "   <p style='font-size: 13px'>时间：" + formatDate(v1.serT) + "</p>" +
			                                    "   <p style='font-size: 13px'>" + (that.iconType <= 3 ? '停车点' : '静止点') + "(" + that.timeDeltaCount(v1.stopT) + ")</p>" +
			                                    "</div>"
			
			                                 AMap.event.addListener(marker, 'mouseover', function (e) {
			                                    infoWindow.setContent(e.target.content);
			                                    infoWindow.open(map, e.target.getPosition());
			                                });
			                                AMap.event.addListener(marker, 'mouseout', function (e) {
			                                    infoWindow.close();
			                                });*/

											marker.on('click', function(e) {
												var i = "";
												AMap.plugin('AMap.Geocoder', function() {
													var geocoder = new AMap
														.Geocoder({
															batch: true
														});
													geocoder.getAddress(e.target
														.getPosition(),
														function(status,
															result) {
															i = result
																.regeocode
																.formattedAddress;
															data.infoWindow
																.setContent(
																	"<div class='markerContent' style='width: 200px;border-radius: 10px;padding:10px 0;background: #ffffff'>" +
																	"   <p style='font-size: 13px'>时间：" +
																	formatDatetime(
																		v1.serT
																	) +
																	"</p>" +
																	"   <p style='font-size: 13px'>" +
																	(data
																		.iconType <=
																		3 ?
																		'停车点' :
																		'静止点'
																	) +
																	"(" +
																	timeDeltaCount(
																		v1
																		.stopT
																	) +
																	")</p>" +
																	"   <p style='font-size: 13px'>地址：" +
																	i +
																	"</p>" +
																	"</div>");
															data.infoWindow
																.open(
																	data.map, e
																	.target
																	.getPosition()
																);
														});
												});
											});


											data.stopList.push(marker)
										}
									}
								});
								data.mileage = sumMileage;

								data.infoWindow.close();
								data.infoWindow2 = new AMap.InfoWindow({
									offset: new AMap.Pixel(5, -10),
									zIndex: 6,
								});


								initPathNavigator();
							} else {
								alert("暂无轨迹信息！");
							}
						} else {
							alert("暂无轨迹信息！");
						}
						data.track = data.cacheTrack;


						setTimeout(function() {
							data.isDataLoading = false;
							data.showLoadingPercentage = false;
						}, (searchDayCount.value > 1 ? 0.75 * 1000 : 0.1 * 1000))
					}
				}
			};


			const initPathNavigator = () => {
				function onload() {
					setTimeout(function() {
						//图片加载成功，重新绘制一次
						data.pathSimplifierIns.renderLater();
					}, 0.100 * 1000);
				};

				function onerror(e) {
					alert('图片加载失败！');
				};


				AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function(PathSimplifier, $) {
					if (!isSupportCanvas()) {
						alert('当前环境不支持 Canvas！');
					} else {
						//创建一个巡航轨迹路线
						data.pathSimplifierIns = new PathSimplifier({
							zIndex: 2, //地图层级，
							map: data.map, //所属的地图实例

							// 巡航路线轨迹列表
							getPath: function(pathData, pathIndex) {
								return pathData.path;
							},
							//hover每一个轨迹点，展示内容
							getHoverTitle: function(pathData, pathIndex, pointIndex) {
								// if (pointIndex >= 0) {
								//     return pathData.name + '，点：' + pointIndex + '/' + pathData.path.length;
								// }
								// return pathData.name + '，点数量' + pathData.path.length;
							},
							renderOptions: {
								renderAllPointsIfNumberBelow: -1, //绘制路线节点，如不需要可设置为-1

								//轨迹线的样式
								pathLineStyle: {
									strokeStyle: '#243290',
									lineWidth: 6,
									dirArrowStyle: true
								},
								pathLineHoverStyle: {
									strokeStyle: '#243290',
									lineWidth: 6,
									dirArrowStyle: true
								},
								pathLineSelectedStyle: {
									strokeStyle: '#243290',
									lineWidth: 6,
									dirArrowStyle: true
								},
								pathNavigatorStyle: {
									width: 36,
									height: 36,
									initRotateDegree: 0,
									content: PathSimplifier.Render.Canvas.getImageContent(
										require("@/assets/" + getShowIcon(data.iconType,
											'markerIcon', '在线', '',
											1)), onload, onerror),

									//轨迹线的样式
									pathLinePassedStyle: {
										strokeStyle: 'green',
										lineWidth: 6,
										dirArrowStyle: true
									}
								}
							}
						});

						if (data.lineArr.length > 0) {
							//设置数据
							data.pathSimplifierIns.setData([{
								name: '路线0',
								path: data.lineArr,
							}]);

							//对第一条线路（即索引 0）创建一个巡航器
							data.pathNavigator = data.pathSimplifierIns.createPathNavigator(0, {
								loop: false, //循环播放
								speed: data.playSpeed, //巡航速度，单位千米/小时
								pathNavigatorStyle: {
									autoRotate: (data.iconType <= 2), //禁止调整方向
								}
							});

							data.pathNavigator.on("move", function() {
								var idx = this.getCursor().idx; //走到了第几个点

								data.passLength = idx;
								if (idx == 0) {
									data.passPercentage = 0
								} else {
									data.passPercentage = parseFloat(((idx + 1) / data.track
										.length) * 100).toFixed(2);
								}

								data.range.val(data.passPercentage);
								data.range.css('background-size', data.passPercentage +
									'% 100%');


								data.infoWindow2.setContent(
									"<div style='padding: 10px 10px;'>" +
									"<div class='right' style='width:100%;float:right;margin: 0 6%;font-size:12px'>" +
									"<p style='line-height:20px'>名称：" + data.plateNo +
									"</p>" +
									"<p style='line-height:20px'>速度：" + data.speedArr[
										idx] + "km/h</p>" +
									"<p style='line-height:20px'>时间：" + formatDatetime(data
										.timeArr[idx]) + "</p>" +
									"</div>" +
									"</div>");
								data.infoWindow2.open(data.map, data.pathNavigator
									.getPosition());


								// 播放轨迹时才执行
								if (data.isPlaying == true) {
									if ((data.passLength) === 0) {
										data.currentTrajectoryIndex = 1;
									} else if (data.passLength > 0 && data.passLength <= data
										.track.length - 1) {
										data.currentTrajectoryIndex = data.passLength + 1;
									} else {
										data.currentTrajectoryIndex = data.passLength;
									}


									// if (that.passLength < that.track.length) {
									//     document.getElementById('scroller').scrollTop = (that.passLength - 1) * 45;
									// } else {
									document.getElementById('scroller').scrollTop = (data
										.passLength) * 45;
									// }

									// map.setCenter(pathNavigator.getPosition())
									if (data.pathNavigator.isCursorAtPathEnd()) {
										data.isPlaying = false;
									}
								}
							});
						}
					}
				});
			};

			const collapseOperationTools = () => {
				// 搜索展开全部地图工具
				data.showOperationTools = !data.showOperationTools;
			};

			const getDistance = () => {
				// 开启测距前，先取消测量面积状态
				if (data.getMeasureArea == true) {
					data.getMeasureArea = false;
				}
				nextTick(() => {
					data.getRuleDistance = !that.getRuleDistance;
				});
			};

			const getSquare = () => {
				// 开启前，先关闭测距状态
				if (data.getRuleDistance == true) {
					data.getRuleDistance = false;
				}

				nextTick(() => {
					data.getMeasureArea = !data.getMeasureArea;
				});
			};

			const changeSatelliteLayer = () => {
				// 切换卫星地图
				data.showSatelliteLayer = !data.showSatelliteLayer;
			};

			const changeTrafficLayer = () => {
				// 切换交通地图
				data.showTrafficLayer = !data.showTrafficLayer;
			};


			return {
				...toRefs(data),
				formatMileage,
				formatDatetime,
				timeDeltaCount,
				bottomCollapse,
				getstartDate,
				getendDate,
				today,
				beforeday,
				afterday,
				queryLine,
				searchDayCount,
				formatProgressPercentage,
				startDate,
				endDate,
				playButton,
				speedDown,
				speedUp,
				swipeRange,
				finishSwipeRange,
				clickTrajectoryRow,
				collapseOperationTools,
				getDistance,
				getSquare,
				changeSatelliteLayer,
				changeTrafficLayer,
			};
		},
	});
</script>

<style scoped>
	.analyse-warp {
		padding: 0 25px;
		height: 70px;
		background: #fff;
		display: flex;
		align-items: center;
		border: 1px solid #e5e5e5;
		box-sizing: border-box;
	}

	.analyse-warp .btn {
		padding: 10.5px 30px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.content {
		position: relative;
		font-size: unset;
	}

	#map-container {
		/* width: 100%;
		height: 100%;*/
		/* height: calc(100% - 100px); */
		/* position: relative; */

		width: 100%;
		height: 100%;

		position: absolute;

		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: row;
	}

	#container {
		width: 100%;
	}

	.order-container {
		position: relative;
		margin-top: 10px;
		width: 350px;
		height: calc(95% - 20px);
		background: #fff;
		z-index: 10;
		border: 1px solid #e5e5e5;
		border-top: none;
		float: right;
	}

	.order-tit {
		width: 100%;
		height: 50px;
		border-bottom: 1px solid #e5e5e5;
		font-size: 16px;
		color: #333;
		text-align: center;
		text-indent: 30px;
		line-height: 50px;
		font-weight: 400;
	}

	.order-tit span {
		cursor: pointer;
		margin-right: 20px;
		background: #ffffff !important;
		color: #000000 !important;
	}

	.order-tit span.active {
		background: #ffffff !important;
		color: #243290 !important;
	}

	.order-list {
		width: 100%;
		height: calc(100% - 50px);
		overflow: auto;
	}

	.order-item {
		width: 100%;
		padding-top: 15px;
		padding-bottom: 10px;
		border-bottom: 1px solid #e5e5e5;
		display: flex;
	}

	.order-item img {
		width: 20px;
		height: 20px;
		margin-left: 20px;
	}

	.order {
		flex: 1;
		margin-left: 10px;
	}

	.order div {
		font-size: 14px;
		text-align: left;
		margin-bottom: 5px;
		font-size: 12px;
		color: #666;
	}

	.order div:nth-of-type(1) {
		font-size: 14px;
		color: #333;
	}

	.address {
		/* width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
		width: 145px;
	}

	.maptop_input {
		width: 150px;
		height: 30px;
	}

	.mapsearch_btn {
		width: 90px;
		height: 30px;
		background: #243290;
		border-radius: 4px;
		cursor: pointer;
		text-align: center;
		line-height: 30px;
		font-size: 14px;
		color: #ffffff;
		margin-left: 10px;
	}

	.bottom_content {
		width: 100%;
		height: calc(100% - 120px - 20px);
		background: #ffffff;
	}

	.bottom_content .table_container {
		width: calc(100% - 20px);
		height: calc(100% - 80px);
		margin: 0 auto;
		padding-top: 10px;
	}

	.marker-image {
		width: 40px;
		height: 40px;
	}

	.amap-container img {
		width: 40px;
		height: 40px;
	}

	#countdown {
		display: inline-block;
		position: absolute;
		left: 2.5%;
		top: 2.5%;
		font-size: 14px;
		margin-left: 15px;
		color: #000000;
		z-index: 999;
		padding: 5px 8px;
		background: #e5e5e5;
	}

	#countdown #countDownTime {
		color: #ff5037;
		width: 15px;
		display: inline-block;
		text-align: center;
	}

	/* ---------------------------------------------------------------------------------------------------------- */
	.info-box {
		position: absolute;
		top: 20px;
		left: 2.5%;
		z-index: 999;

		width: 300px;
		/*height: 300px;*/
		padding: 20px 20px 30px 20px;

		/*background: #ffffff;*/
		background: url("~@/assets/images/background-vehicleInfo.png") no-repeat center center;
		background-size: 100% 100%;
		/*border: 1px solid #e5e5e5;*/
		/*border-radius: 5px;*/
		font-size: 15px;
	}

	.info-box .info-row {
		width: 100%;
		min-height: 35px;

		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.info-box .operation-row {
		width: 100%;
		min-height: 40px;

		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.info-box label {
		display: inline-block;
		width: 75px;
		text-align: right;
		margin-right: 5px;
	}

	.info-box .operation-row input[type="text"] {
		width: calc(100% - 85px);
		height: 30px;

		padding: 0 5px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		font-size: 14px;
	}

	.info-box .operation-row input[type="text"]:focus {
		outline: none;
	}

	.info-box .operation-row span.btn {
		padding: 5px 10px;
		border-radius: 5px;
		color: #ffffff;

		font-size: 13px;
		cursor: pointer;
	}


	.info-box .operation-row select#stopTime,
	.info-box .operation-row select#trackType {
		width: 80px;
		height: 30px;

		padding: 0 5px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		font-size: 14px;
		cursor: pointer;
	}

	.info-box .operation-row select#trackType {
		width: 100px;
		height: 30px;

		padding: 0 5px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		font-size: 14px;
		cursor: pointer;
	}

	.info-box .operation-row .buttonGroup {
		width: calc(100% - 85px);
		height: 100%;

		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.info-box .operation-row .buttonGroup span.btn {
		padding: 5px 10px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		color: #666666;
		background: transparent;

		font-size: 13px;
		cursor: pointer;
	}

	.info-box .operation-row .buttonGroup span.btn:hover {
		background: #243290;
		color: #ffffff;
	}

	.info-box .operation-row span#queryLine {
		width: 100%;
		text-align: center;
	}


	.info-box .operation-row img {
		margin-right: 10px;
		cursor: pointer;
		vertical-align: middle;
	}

	.info-box .operation-row input[type=range] {
		width: 42%;
		-webkit-appearance: none;
		border-radius: 10px;
		background: -webkit-linear-gradient(#243290, #243290) no-repeat;
		background-size: 0 100%;
		vertical-align: middle;
	}

	.info-box .operation-row input[type=range]:focus {
		outline: none;
	}

	.info-box .operation-row input[type=range]::-moz-range-thumb {
		-webkit-appearance: none;
		margin-top: -3px;
		background: #ffffff;
		border-radius: 50%;
		border: 0.4em solid #243290;
		box-shadow: 0 .125em .125em #3b4547;
		cursor: pointer;
	}

	.info-box .operation-row input[type=range]::-moz-range-track {
		height: 15px;
		border-radius: 8px;
		border: 1px solid #e5e5e5;
		/*background: #4D4D4D;*/
	}

	.info-box .operation-row input[type=range]::-webkit-slider-thumb {
		-webkit-appearance: none;
		height: 20px;
		width: 20px;
		margin-top: -3px;
		background: #ffffff;
		border-radius: 50%;
		border: 0.4em solid #243290;
		box-shadow: 0 .125em .125em #3b4547;
		cursor: pointer;
	}

	.info-box .operation-row input[type=range]::-webkit-slider-runnable-track {
		height: 15px;
		border-radius: 8px;
		border: 1px solid #e5e5e5;
		/*background: #4D4D4D;*/
	}

	.info-box .operation-row #collapse {
		line-height: normal;
		margin-left: 10px;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.info-box .operation-row #collapse img {
		background: white;
		border-radius: 50%;
		margin: 0 0 0 3px;
		width: 18px;
	}

	/* ---------------------------------------------------------------------------------------------------------- */

	/* ---------------------------------------------------------------------------------------------------------- */
	.detailList-row {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 1.5%;
		margin: 0 auto;

		z-index: 199;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	.detailList {
		width: 90px;
		height: 25px;
		line-height: 25px;
		background: #243290;
		border-radius: 4px;
		color: #fff;
		font-size: 13px;
		text-align: center;
		display: inline-block;
		vertical-align: middle;
		cursor: pointer;
	}

	.arrow-down {
		width: 16px;
		height: 16px;
		display: inline-block;
		vertical-align: text-bottom;
		margin-right: 5px;
	}


	.satellitePositioning {
		color: #222222 !important;
	}

	.stationPositioning {
		color: #999999 !important;
	}

	.scroller {
		height: 100%;
		overflow: scroll;
	}

	.scroller::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	.scroller::-webkit-scrollbar-thumb {
		background: #243290;
		border-radius: 20px;
	}


	.el-progress-bar__outer {
		background-color: #DFDFDF;
	}

	/* ------------------------------------------*/

	.contenBox {
		height: calc(100% - 50px);
		position: relative;
	}


	@media screen and (max-height: 767px) {
		#trackInfo {
			height: 210px;
		}

	}

	@media screen and (min-height: 768px) {
		#trackInfo {
			height: 250px;
		}

	}

	#trackInfo {
		width: 95%;
		background: url("~@/assets/images/background-trackInfo.png") no-repeat center center;
		background-size: 100% 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin: 0 auto;
		z-index: 199;
		cursor: default;
	}

	#trackInfo #list #listBox {
		width: 100%;
		height: 140px;
		overflow: auto;
	}

	#trackInfo #list #listBox::-webkit-scrollbar {
		width: 8px;
	}

	#trackInfo #list #listBox::-webkit-scrollbar-thumb {
		border-radius: 20px;
		background: #243290;
	}

	#trackInfo .title {
		height: 40px;
		line-height: 40px;
		border-bottom: 2px solid #243290;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	#trackInfo #equipmentList .title div:last-child img {
		width: 16px;
		vertical-align: middle;
		cursor: pointer;
	}

	#trackInfo .title h5 {
		font-size: 15px;
		font-weight: bold;
		color: #243290;
	}

	#trackInfo #list {
		width: 100%;
		height: 180px;
	}

	#trackInfo #list li {
		height: 35px;
		line-height: 35px;
	}

	#list #listBox li:last-child,
	.list #listBox li:last-child {
		border-bottom: none;
	}

	#trackInfo #list li:hover {
		background: transparent;
	}

	#trackInfo #list li:first-child span {
		font-size: 13px;
	}

	#trackInfo #list #listBox li span {
		font-size: 12px;
	}

	#trackInfo #list li:hover span {
		color: #666666;
	}

	#trackInfo #list li span {
		font-size: 12px;
	}

	#trackInfo #trackDetail {
		height: 89%;
		font-size: 12px;
		padding: 3px 15px;
	}

	#trackInfo #trackDetail .title div.operation-item {
		min-height: 100%;
		max-height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	#trackInfo #trackDetail .title span#deviceId,
	#trackInfo #trackDetail .title span#accOnTime,
	#trackInfo #trackDetail .title span#carStopTime,
	#trackInfo #trackDetail .title span#maxSpeed,
	#trackInfo #trackDetail .title span#averageSpeed {
		color: #243290;
		margin-right: 15px;
	}

	#trackInfo #trackDetail .title span#mileage {
		color: #243290;
		margin-right: 10px;
	}

	#trackInfo #trackDetail .title span.operation {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		margin: 0 10px;
		cursor: pointer;
	}

	#trackInfo #trackDetail .title span.operation span {
		margin-left: 5px;
	}

	#trackInfo #trackDetail .title div:last-child span {
		font-size: 13px;
	}

	#trackInfo #trackDetail .title div:last-child span img {
		width: 20px;
		vertical-align: middle;
	}

	#trackInfo #trackDetail #list li span:first-child {
		display: inline-block;
		width: 4.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(2) {
		display: inline-block;
		width: 12.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(3) {
		display: inline-block;
		width: 12.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(4) {
		display: inline-block;
		width: 6.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(5) {
		display: inline-block;
		width: 6.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(6) {
		display: inline-block;
		width: 8.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(7) {
		display: inline-block;
		width: 6.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(8) {
		display: inline-block;
		width: 6.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(9) {
		display: inline-block;
		width: 15.33%;
	}

	#trackInfo #trackDetail #list li span:nth-child(10) {
		display: inline-block;
		width: 9.33%;
	}

	#trackInfo #trackDetail #list li span:last-child {
		display: inline-block;
		width: 12.33%;
	}

	#trackInfo #trackDetail #list #listBox li {
		height: auto;
		min-height: 45px;
		line-height: 45px;
	}

	#trackInfo #trackDetail #list #listBox li span {
		vertical-align: middle;
	}

	#trackInfo #trackDetail #list #listBox li span:last-child {
		white-space: normal;
		line-height: 20px;
	}

	.online {
		color: #01AC0D !important;
	}

	.offline {
		color: #CCCCCC !important;
	}

	.sleep {
		color: #243290 !important;
	}

	/* ---------------------------------------------------------------------------------------------------------- */
	#selectTerminal-panel {
		display: none;
		width: 100%;
		height: 250px;
		position: absolute;
		top: 39px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		background: #ffffff;
		z-index: 999999;
		overflow: auto;
	}

	#selectTerminal-panel::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	#selectTerminal-panel::-webkit-scrollbar-thumb {
		border-radius: 20px;
		background: #999999;
	}

	#selectTerminal-panel #list {
		width: 100%;
		height: 100%;
		margin: 0 auto;
		/*height: 59%;*/
	}

	#selectTerminal-panel #list li {
		height: 45px;
		line-height: 45px;
		border-top: 1px solid #E5E5E5;
		font-size: 0;
		position: relative;
		cursor: pointer;
	}

	#selectTerminal-panel #list #listBox li:hover {
		background: #243290;
	}

	#selectTerminal-panel #list #listBox li:hover span {
		color: #fff;
	}

	#selectTerminal-panel #list li span {
		display: inline-block;
		width: 8.33%;
		text-align: center;
		font-size: 18px;
		color: #243290;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		position: relative;
		margin: 0;
	}

	#selectTerminal-panel #list li span .btn {
		display: inline-block;
		color: #fff;
		font-size: 15px;
		width: 60px;
		height: 30px;
		line-height: 30px;
		background: #243290;
		border-radius: 4px;
		vertical-align: middle;
		cursor: pointer;
	}

	#selectTerminal-panel #list li span a {
		color: #fff;
	}

	#selectTerminal-panel #list #listBox li span {
		font-size: 13px;
		color: #666;
	}

	#selectTerminal-panel #list li:first-child span {
		font-size: 14px;
	}

	#selectTerminal-panel #list #listBox li:last-child {
		border-bottom: 1px solid #E5E5E5;
	}


	#selectTerminal-panel #list #listBox li span input[type="checkbox"] {
		width: auto;
		height: auto;
		cursor: pointer;
	}

	#selectTerminal-panel #list li span:first-child {
		width: 12.33%;
	}

	#selectTerminal-panel #list li span:nth-child(2) {
		width: 45.33%;
	}

	#selectTerminal-panel #list li span:last-child {
		width: 42.33%;
	}

	/* ------------------------------------------*/
	.input_cell {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.input_cell .label {
		width: 65px;
		text-align: left;
	}

	.input_box {
		flex: 1;
		height: 100%;
		margin-left: 10px;
		display: flex;
		align-items: center;
	}

	.bgStyle {
		background: #243290 !important;
	}

	/* ------------------------------------------------- */

	#mapTools {
		height: 40px;
		padding: 0 5px;

		background: #FFFFFF;
		border-radius: 5px;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
		display: flex;
		align-items: center;
		justify-content: flex-start;

		position: absolute;
		right: 3%;
		top: 7.5%;
		z-index: 999;
	}

	#mapTools .tool-item {
		min-width: 80px;
		height: 100%;

		font-size: 13px;
		color: #333333;
		cursor: pointer;
		border-right: 1px solid #D5D5D5;

		display: flex;
		align-items: center;
		justify-content: center;
	}

	#mapTools .tool-item:last-child {
		border-right: none;
	}

	#mapTools .tool-item .tool-icon-search {
		width: 18px;
		margin-right: 5px;
	}

	#mapTools .tool-item .tool-icon {
		width: 20px;
		margin-right: 5px;
	}

	.bgBlock {
		position: absolute;
		width: 100%;
		height: 100%;
		background: #fff;
		z-index: 9999999;
		background: rgba(255, 255, 255, 0.6);
		left: 0;
		top: 0;
	}

	.load {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 999;
		text-align: center;
		padding: 10px 50px;
	}
</style>